import { render, staticRenderFns } from "./PersonalRealName.vue?vue&type=template&id=ee244ba4&scoped=true&"
import script from "./PersonalRealName.vue?vue&type=script&lang=js&"
export * from "./PersonalRealName.vue?vue&type=script&lang=js&"
import style0 from "./PersonalRealName.vue?vue&type=style&index=0&id=ee244ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee244ba4",
  null
  
)

export default component.exports